import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclUtilGmapService {

  constructor() { }

  initMapLabel(google) {
    function MapLabel(optOptions) {
      this.set('fontFamily', 'sans-serif');
      this.set('fontSize', 12);
      this.set('fontColor', '#000000');
      this.set('strokeWeight', 4);
      this.set('strokeColor', '#ffffff');
      this.set('align', 'center');

      this.set('zIndex', 1e3);

      this.setValues(optOptions);
    }
    MapLabel.prototype = new google.maps.OverlayView();

    // tslint:disable-next-line: no-string-literal
    window['MapLabel'] = MapLabel;

    /** @inheritDoc */
    MapLabel.prototype.changed = function(prop) {
      switch (prop) {
          case 'fontFamily':
          case 'fontSize':
          case 'fontColor':
          case 'strokeWeight':
          case 'strokeColor':
          case 'align':
          case 'text':
              return this.drawCanvas_();
          case 'maxZoom':
          case 'minZoom':
          case 'position':
              return this.draw();
      }
    };
    /**
     * Draws the label to the canvas 2d context.
     * @private
     */
    MapLabel.prototype.drawCanvas_ = function() {
      const canvas = this.canvas_;
      if (!canvas) { return; }

      const style = canvas.style;
      style.zIndex = /** @type number */(this.get('zIndex'));

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = this.get('strokeColor');
      ctx.fillStyle = this.get('fontColor');
      ctx.font = this.get('fontSize') + 'px ' + this.get('fontFamily');

      const strokeWeight = Number(this.get('strokeWeight'));

      const text = this.get('text');
      if (text) {
          if (strokeWeight) {
              ctx.lineWidth = strokeWeight;
              ctx.strokeText(text, strokeWeight, strokeWeight);
          }

          ctx.fillText(text, strokeWeight, strokeWeight);

          const textMeasure = ctx.measureText(text);
          const textWidth = textMeasure.width + strokeWeight;
          style.marginLeft = this.getMarginLeft_(textWidth) + 'px';
          // Bring actual text top in line with desired latitude.
          // Cheaper than calculating height of text.
          style.marginTop = '-1em';
      }
    };
    /**
     * @inheritDoc
     */
    MapLabel.prototype.onAdd = function() {
      const canvas = this.canvas_ = document.createElement('canvas');
      const style = canvas.style;
      style.position = 'absolute';

      const ctx = canvas.getContext('2d');
      ctx.lineJoin = 'round';
      ctx.textBaseline = 'top';

      this.drawCanvas_();

      const panes = this.getPanes();
      if (panes) {
          panes.mapPane.appendChild(canvas);
      }
    };
    // tslint:disable-next-line: no-string-literal
    MapLabel.prototype['onAdd'] = MapLabel.prototype.onAdd;

    /**
     * Gets the appropriate margin-left for the canvas.
     * @private
     * @param {number} textWidth  the width of the text, in pixels.
     * @return {number} the margin-left, in pixels.
     */
    MapLabel.prototype.getMarginLeft_ = function(textWidth) {
      switch (this.get('align')) {
          case 'left':
              return 0;
          case 'right':
              return -textWidth;
      }
      return textWidth / -2;
    };
    /**
     * @inheritDoc
     */
    MapLabel.prototype.draw = function() {
      const projection = this.getProjection();

      if (!projection) {
          // The map projection is not ready yet so do nothing
          return;
      }

      if (!this.canvas_) {
          // onAdd has not been called yet.
          return;
      }

      const latLng = /** @type {google.maps.LatLng} */ (this.get('position'));
      if (!latLng) {
          return;
      }
      const pos = projection.fromLatLngToDivPixel(latLng);

      const style = this.canvas_.style;

      // tslint:disable-next-line: no-string-literal
      style['top'] = pos.y + 'px';
      // tslint:disable-next-line: no-string-literal
      style['left'] = pos.x + 'px';

      // tslint:disable-next-line: no-string-literal
      style['visibility'] = this.getVisible_();
    };
    // tslint:disable-next-line: no-string-literal
    MapLabel.prototype['draw'] = MapLabel.prototype.draw;

    /**
     * Get the visibility of the label.
     * @private
     * @return {string} blank string if visible, 'hidden' if invisible.
     */
    MapLabel.prototype.getVisible_ = function() {
      const minZoom = /** @type number */(this.get('minZoom'));
      const maxZoom = /** @type number */(this.get('maxZoom'));

      if (minZoom === undefined && maxZoom === undefined) {
          return '';
      }

      const map = this.getMap();
      if (!map) {
          return '';
      }

      const mapZoom = map.getZoom();
      if (mapZoom < minZoom || mapZoom > maxZoom) {
          return 'hidden';
      }
      return '';
    };

    /**
     * @inheritDoc
     */
    MapLabel.prototype.onRemove = function() {
      const canvas = this.canvas_;
      if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
      }
    };
    // tslint:disable-next-line: no-string-literal
    MapLabel.prototype['onRemove'] = MapLabel.prototype.onRemove;

    return MapLabel;
  }
  convertGPSToAddress(lat, lon, key, $q, $http) {
    const deferrer = $q.defer();

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + key;
    $http.get(link).then(function(data) {
        if (data.data.status === 'OK' ) {
            deferrer.resolve(data);
        } else {
          deferrer.reject('Error: ' + data.data.error_message);
        }
    }).catch(function(error) {
        console.log('Error : ' + error);
        deferrer.reject(error);
    });

    return deferrer.promise;
  }
  getGeoCoors(SearchResultsProcessor, results, geozonesData, geozonesName, google, cb) {
    const finalData = [];
    SearchResultsProcessor.processSearchResults(results, (itemData) => {
      if (!itemData) { return; }
      // elementProcessingCallback
      const gCoors = [];
      const imeiGeoData  = itemData[geozonesData];
      for (let j = 0; j < imeiGeoData.features.length; j++) {
        const geometry = imeiGeoData.features[j].geometry;
        const coordinates = geometry.coordinates;
        if ( geometry.type === 'LineString') {
          for (const key in coordinates) {
            if (coordinates.hasOwnProperty(key)) {
              const gCoor = new google.maps.LatLng(coordinates[key][1], coordinates[key][0]);
              gCoors.push(gCoor);
            }
          }
          finalData.push({name: itemData[geozonesName],
            coors: gCoors,
            shape: 'Line'});
        } else if (geometry.type === 'Polygon') {
            for (const key in coordinates[0]) {
              if (coordinates[0].hasOwnProperty(key)) {
                const gCoor = new google.maps.LatLng(coordinates[0][key][1],coordinates[0][key][0]);
                gCoors.push(gCoor);
              }
            }
            finalData.push({name: itemData[geozonesName],
              coors: gCoors,
              shape: 'Polygon'});
        } else if (geometry.type === 'Point') {
            const gCoor = new google.maps.LatLng(coordinates[1], coordinates[0]);
            gCoors.push(gCoor);
            finalData.push({name: itemData[geozonesName],
              coors: gCoors,
              shape: 'Point'});
        } else if (geometry.type === 'MultiPolygon') {
          for (let h = 0; h < coordinates.length; h++) {
            for (const key in coordinates[h]) {
              if (coordinates[h].hasOwnProperty(key)) {
                const gCoor = new google.maps.LatLng(coordinates[h][key][1], coordinates[h][key][0]);
                gCoors.push(gCoor);
              }
            }
            finalData.push({name: itemData[geozonesName],
              coors: gCoors,
              shape: 'Polygon'});
          }
        } else {
          console.log(geometry.type + ' is not handle yet');
        }
      }
    }, () => {
      // completionCallback
      console.log('the "processSearchResults" is complete');
    });
    if (cb && typeof cb === 'function') {
      cb(finalData);
    }
  }
}
